module.exports = __webpack_public_path__ + "media/Images/icon-blue-graph-o-d760ce5596155ea80a394ad1db692311.svg";